const incidentSources = Object.freeze({
  trigger: 'Trigger',
  parser: 'Parser',
  webHook: 'WebHook',
});

export default incidentSources;
